import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import HeroSection from "../../elements/HeroSection";
import EnrollFrame from "../../elements/EnrollFrame";
import SparrowSection from "../approachPage/SparrowSection";
import { DiscoverPotentialSection } from "../programPage/DiscoverPotentialSection";
import { LookingSolution } from "./LookingSolution";
import WhyUsSection from "./WhyUsSection";

const NurseryPage: React.FC = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CssBaseline />
      <HeroSection
        mainTitle={<>{t("NurseryPage.mainTitle")}</>}
        secondaryTitle={t("NurseryPage.secondaryTitle")}
        backgroundImageUrl={"/nurseryPage/hero.webp"}
        altImage={t("AltImages.alt_image_nursery")}
        buttonText={t("NurseryPage.buttonText")}
        buttonOnClickPath={"enroll"}
        isApproachPage={true}
      />
      <SparrowSection
        image="/birds/blue.webp"
        title1={t("NurseryPage.SparrowSection.title_1")}
        description1={t("NurseryPage.SparrowSection.description_1")}
        marginTop={true}
        marginBottom={isMobile ? false : true}
        changeColor={true}
      />
      <DiscoverPotentialSection
        title={t("NurseryPage.DiscoverPotentialSection.title")}
        description={t("NurseryPage.DiscoverPotentialSection.description")}
        description1={t("NurseryPage.DiscoverPotentialSection.description_1")}
        image="/nurseryPage/kinder4.webp"
      />
      <LookingSolution />
      <WhyUsSection section="nursery" />
      <EnrollFrame />
    </>
  );
};

export default NurseryPage;
